import LinkPreviewCard from "./LinkPreviewCard";
import blogData from "../utils/blogData";

const LinkPreview = () => {
  return (
    <div>
      <h1
        style={{
          fontSize: "2rem",
          color: "#b3c5ef",
          letterSpacing: "1px",
        }}
      >
        <span style={{ color: "#3ABFF8" }}>📚 </span>
        Blogs
      </h1>
      <div
        style={{
          marginBottom: "15rem",
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "5rem",
          marginTop: "1rem",
        }}
      >
        {blogData.map((blog, index) => (
          <LinkPreviewCard key={index} blogData={blog} />
        ))}
      </div>
    </div>
  );
};

export default LinkPreview;
